(function () {
    'use strict';
    angular.module('Login').controller('ConfirmChangeAuthModalController', ConfirmChangeAuthModalController)
    ConfirmChangeAuthModalController.$inject=[
        '$uibModalInstance'
    ]
    
    function ConfirmChangeAuthModalController(
        $uibModalInstance
        
    ){
        var vm = this;
        vm.confirm = confirm;
        vm.close = closed;

        function closed(){
            $uibModalInstance.close()
        }

        function confirm(){
            $uibModalInstance.close(true)
        }
    }

})();



//////////////////
// WEBPACK FOOTER
// ./auth/js/controllers/modal/confirmChangeAuthModalController.js
// module id = 147
// module chunks = 0